import { Controller } from 'stimulus';
import { addShortcut } from '@core/core/utils/shortcuts';

class DisableAfterClick {
  constructor(button) {
    this.button = button;
    this.clicked = false;
    this.form = button.closest('form');
  }

  connect() {
    this.button.addEventListener('click', this.#disableSubmitOnClick.bind(this));
    this.form?.addEventListener('input', this.#enableSubmitOnFormChange.bind(this));
  }

  disconnect() {
    this.button.removeEventListener('click', this.#disableSubmitOnClick.bind(this));
    this.form?.removeEventListener('input', this.#enableSubmitOnFormChange.bind(this));
  }

  #disableSubmitOnClick(event) {
    if (this.clicked) {
      // If button has already been clicked, prevent further action
      event.preventDefault();
      return false;
    }
    setTimeout((() => { this.button.disabled = true; }), 10); // Short delay to ensure form submission
    this.clicked = true; // Mark as clicked to prevent double submission
  }

  #enableSubmitOnFormChange() {
    // Re-enable the button if it was previously clicked and the form had a validation error
    if (this.clicked) {
      this.button.disabled = false;
      this.clicked = false; // Reset the clicked state
    }
  }
}

export default class extends Controller {
  connect() {
    addShortcut(this.element.getAttribute('shortcut'), () => this.element.click());
    if (this.element.dataset.disableAfterClick === 'true') {
      this.disableAfterClick = new DisableAfterClick(this.element);
      this.disableAfterClick.connect();
    }
  }

  disconnect() {
    this.disableAfterClick?.disconnect();
  }

  goBack(event) {
    event.preventDefault();
    history.back();
  }
}
